import { getEntityIdFromCurrentUrl } from 'utils/urlStoreUtils'
import { useOpenCoverImagePrompt } from '../insertButtonHooks/useOpenCoverImagePrompt'
import { useContext } from 'react'
import { SingleMenuDropdownContext } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownStore'
import { SingleMenuDropdownItem } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownItem'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const InsertCoverImageButton = () => {
  const view = useEditorView()
  const dropdownStore = useContext(SingleMenuDropdownContext)
  const articleId = getEntityIdFromCurrentUrl() ?? ''
  const openPrompt = useOpenCoverImagePrompt(view, articleId)

  const onClick = () => {
    dropdownStore?.hardClose()
    openPrompt()
  }

  return (
    <SingleMenuDropdownItem
      icon={<ToolbarIcon name={IconName.CoverImage} />}
      label="Cover Image"
      handleClick={onClick}
    />
  )
}
